import { EMPTY_STRING } from "@/common/helpers/constants";
import type { App, InjectionKey } from "vue";

export interface ComponentInstance {
  send: (data: { UUID: string }, origin: string) => void;
  sendToVeins: (data: { UUID: string }, origin: string) => void;
  listen: (callBack: (ev: MessageEvent) => void) => void;
  remove: (callBack: (ev: MessageEvent) => void) => void;
}

export const eventbusKey = Symbol() as InjectionKey<ComponentInstance>;
export default {
  install: (app: App) => {
    const send = (
      data: { UUID: string } = { UUID: EMPTY_STRING },
      origin = window.location.origin
    ) => {
      const params = !data.UUID
        ? { ...data, UUID: import.meta.env.VITE_APP_UUID }
        : data;
      window.top?.postMessage(params, origin);
    };

    const sendToVeins = (
      data: { UUID: string } = { UUID: EMPTY_STRING },
      origin = import.meta.env.VITE_APP_ROUTES_HOST
    ) => {
      const params = !data.UUID
        ? { ...data, UUID: import.meta.env.VITE_APP_VEINS_UUID }
        : data;
      const iframe = document.querySelector(
        "#veins-iframe"
      ) as HTMLIFrameElement;
      if (iframe) iframe?.contentWindow?.postMessage(params, origin);
    };

    const listen = (callBack: (ev: MessageEvent) => void) =>
      window.addEventListener(
        "message",
        (ev: MessageEvent) => {
          if (ev.data.UUID === import.meta.env.VITE_APP_UUID) {
            callBack(ev);
          }
        },
        false
      );

    const remove = (callBack: () => void) => {
      window.removeEventListener("message", callBack, false);
    };

    const methods = { send, sendToVeins, listen, remove } as ComponentInstance;
    app.config.globalProperties.$eventbus = methods;
    globalThis.$eventbus = methods;
    app.provide(eventbusKey, methods);
    app.provide("eventbus", methods);
  },
};
